function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCalendarIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12,
    height: 16,
    viewBox: "0 0 14 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M10.5 9.125v.75a.376.376 0 0 1-.375.375H7.75v2.375a.376.376 0 0 1-.375.375h-.75a.376.376 0 0 1-.375-.375V10.25H3.875a.376.376 0 0 1-.375-.375v-.75a.376.376 0 0 1 .375-.375H6.25V6.375A.376.376 0 0 1 6.625 6h.75a.376.376 0 0 1 .375.375V8.75h2.375a.376.376 0 0 1 .375.375zM14 3.5v11a1.5 1.5 0 0 1-1.5 1.5h-11A1.5 1.5 0 0 1 0 14.5v-11A1.5 1.5 0 0 1 1.5 2H3V.375A.376.376 0 0 1 3.375 0h1.25A.376.376 0 0 1 5 .375V2h4V.375A.376.376 0 0 1 9.375 0h1.25A.376.376 0 0 1 11 .375V2h1.5A1.5 1.5 0 0 1 14 3.5zm-1.5 10.813V5h-11v9.313a.188.188 0 0 0 .188.188h10.625a.188.188 0 0 0 .187-.188z",
    style: {
      fill: "#0f8560",
      opacity: 0.998
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendarIcon);
export default __webpack_public_path__ + "static/media/calendar-icon.45b1488c.svg";
export { ForwardRef as ReactComponent };